var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassHomeScienceCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C2 2.39543 2.89543 1.5 4 1.5H15C16.1046 1.5 17 2.39543 17 3.5V14.5C17 15.6046 16.1046 16.5 15 16.5H4C2.89543 16.5 2 15.6046 2 14.5V3.5Z",
    fill: "#ADE25D",
    stroke: "#CAED97",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49552 13.2847C8.10439 13.6789 7.46704 13.6789 7.07591 13.2847L4.10009 10.2861C3.76793 9.95137 3.76793 9.4114 4.10009 9.07669C4.43553 8.73867 4.982 8.73829 5.31791 9.07584L7.0759 10.8424C7.4672 11.2356 8.10378 11.2352 8.49453 10.8414L13.6782 5.61794C14.0158 5.27778 14.5661 5.27876 14.9025 5.6201C15.2336 5.95609 15.2326 6.49594 14.9003 6.83076L8.49552 13.2847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassHomeScienceCheckBox);
export default __webpack_public_path__ + "static/media/ClassHomeScienceCheckBox.378f30cdf04de7bb2966bbf9cdb11128.svg";
export { ForwardRef as ReactComponent };